// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/3p-care-team.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/3p-care-team/3p-care-team.js';

mount([g0]);
